import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font,
  Link,
  
} from "@react-pdf/renderer";

import imgKkp from "../../assets/img/logo-kkp.png";
import srcArial from "../../assets/font/arial/arial.ttf";
import srcArialBold from "../../assets/font/arial/ARIBL0.ttf";

// REGISTER FONT (GLOBAL, SEKALI)
Font.register({ family: "Arial", src: srcArial });
Font.register({ family: "Arial-Bold", src: srcArialBold });
// Font.registerHyphenationCallback(word => [word]);


export const s = StyleSheet.create({
  page: {
    paddingTop: 10,
    paddingLeft:20,
    paddingRight:20,
    fontSize: 10,
    fontFamily: "Arial",
  },

  title: {
    textAlign: "center",
    fontFamily: "Arial-Bold",
    marginVertical: 6,
  },

  subtitle: {
    textAlign: "center",
    fontSize: 9,
    marginBottom: 10,
  },

  row: {
    flexDirection: "row",
    marginBottom: 4,
  },

  noCol: {
    width: 18,
  },

  label: {
    width: 140,
  },

  colon: {
    width: 6,
  },

  value: {
    flex: 1,
  },

  fieldRow: {
    flexDirection: "row",
    marginBottom: 2,
  },

  bold: {
    fontFamily: "Arial-Bold",
  },

  ttd: {
    marginTop: 30,
    alignItems: "center",
  },
  table: {
  display: "table",
  width: "100%",
  borderWidth: 1,
  borderStyle: "solid",
},

tableRow: {
  flexDirection: "row",
},

tableColNo: {
  width: "3.5%",
  borderRightWidth: 1,
  borderBottomWidth: 1,
  padding: 4,
},

tableColLabel: {
  width: "47%",
  borderRightWidth: 1,
  borderBottomWidth: 1,
  padding: 4,
},

tableColValue: {
  width: "50%",
  borderBottomWidth: 1,
  padding: 4,
},
tableColLabel2: {
  width: "60%",
  padding: 4,
},
tableColValue2: {
  width: "40%",
   padding: 4,
},

text: {
  fontSize: 10,
  lineHeight: 1.3,
},

});

const data = {
  // PEJABAT PEMBERI PERINTAH
  ppk: "Pejabat Pembuat Komitmen Balai Besar KIPM Jakarta I",

  // PEGAWAI YANG DINAS
  nama: "Galih Pratomo Suwatno",
  nip: "198805242010121002",

  // PANGKAT & JABATAN
  pangkat: "Penata Muda Tk. I, III/b",
  jabatan: "Inspektur Mutu Hasil Perikanan Ahli Mahir / BBKIPM Jakarta I",
  tingkat: "C",

  // MAKSUD PERJALANAN
  maksud:
    "Survailen Penerapan Sistem HACCP dan Pengambilan Sampel Official Control pada Unit Pengolahan Ikan",

  // TRANSPORTASI
  transportasi: "Kendaraan Umum",

  // LOKASI
  berangkat: "Balai Besar KIPM Jakarta I, Tangerang",
  tujuan:
    "PT. Bumi Pertiwi Mulia, Jl. Pergudangan Bandara Mas Blok M No.21, Kota Tangerang",

  // WAKTU
  lama: "1 (Satu) hari",
  tglBerangkat: "8 November 2025",
  tglKembali: "8 November 2025",

  // PENERBIT
  tempat: "Tangerang",
  tanggal: "8 November 2025",

  // PPK TTD
  ppkNama: "Muklasin",
  ppkNip: "198110112008011012",
};


export default function SPPDDepan() {
  return (
    <Document>
    <Page size="A4" style={s.page}>
        <View style={s.tableRow}>
            <View style={s.tableColLabel2}>
           
            </View>
  
                <View style={s.tableColValue2}>
                <Text style={{ fontSize: 9 }}>
                Lampiran VI (1 dari 4){"\n"}
                Keputusan Menteri Keuangan {"\n"}
                Perjalanan Dinas Dalam Negeri Bagi Pejabat {"\n"}
                negara, Pegawai Negeri Sipil dan Pegawai {"\n"}
                Tidak Tetap {"\n"}
                Nomor : 113/PMK.05/2012 {"\n"}
                Tanggal : 3 Juli 2012 
                </Text>
                </View>
            </View>


        <Text style={s.bold}>
            KEMENTERIAN KELAUTAN DAN PERIKANAN {"\n"}
            BALAI BESAR KIPM JAKARTA I
        </Text>

        <View style={s.tableRow}>
            <View style={{ width :'50%' }}> </View>
             <View style={{ width :'10%' }}> 
                <Text style={s.text}>
                Lembar ke
                </Text>
             </View>
                <View style={{ width :'40%'}}>
                <Text style={s.text}>
                : 1
                </Text>
            </View>
        </View>
        <View style={s.tableRow}>
            <View style={{ width :'50%' }}> </View>
             <View style={{ width :'10%' }}> 
                <Text style={s.text}>
                Kode No. 
                </Text>
             </View>
               <View style={{ width :'40%'}}>
                <Text style={s.text}>
                : 1
                </Text>
            </View>
        </View>
        <View style={s.tableRow}>
            <View style={{ width :'50%' }}> </View>
             <View style={{ width :'10%'}}> 
                <Text style={s.text}>
                Nomor 
                </Text>
             </View>
                <View style={{ width :'40%'}}>
                <Text style={s.text}>
                : B.3133/BBKIPM.JKT.I/KP.440/XI/2025
                </Text>
            </View>
        </View>

        <Text style={s.bold}>SURAT PERJALANAN DINAS</Text>

     <View style={s.table}>
        {/* 1 */}
        <View style={s.tableRow}>
            <View style={s.tableColNo}>
            <Text style={s.text}>1.</Text>
            </View>
            <View style={s.tableColLabel}>
            <Text style={s.text}>
                Pejabat berwenang yang memberi perintah
            </Text>
            </View>
            <View style={s.tableColValue}>
            <Text style={s.text}>{data.ppk}</Text>
            </View>
        </View>

        {/* 2 */}
        <View style={s.tableRow}>
            <View style={s.tableColNo}>
            <Text style={s.text}>2.</Text>
            </View>
            <View style={s.tableColLabel}>
            <Text style={s.text}>Nama / NIP</Text>
            </View>
            <View style={s.tableColValue}>
            <Text style={s.text}>
                {data.nama} / {data.nip}
            </Text>
            </View>
        </View>

        <View style={s.tableRow}>
            <View style={s.tableColNo}>
            <Text style={s.text}>7.</Text>
            </View>
            <View style={{ width :"97%", 
                    borderBottomWidth: 1,
                     }}>
                <View style={s.tableRow}>
                    <View style={{ width: "3%"}}>
                        <Text style={[s.text,{paddingLeft:4, paddingTop:4}]}>a.</Text>
                    </View>
                    <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4,paddingTop:4}]}>
                             Pangkat dan Golongan ruang gaji Menurut PP No.6 Tahun 1997
                        </Text>
                    </View>
                    <View style={{ width: "3%"}}>
                        <Text style={[s.text,{paddingLeft:4,paddingTop:4}]}>a.</Text>
                    </View>
                    <View style={{ width : "46%" }}>
                        <Text style={[s.text,{paddingTop:4}]}>
                            Penata Muda TK.I, III/b
                        </Text>
                    </View>
                </View>
                
                    <View style={s.tableRow}>
                        <View style={{ width: "3%"}}>
                            <Text style={[s.text,{paddingLeft:4}]}>b.</Text>
                        </View>
                        <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4}]}>
                                Jabatan/Instansi
                            </Text>
                        </View>
                        <View style={{ width: "3%"}}>
                        <Text style={[s.text,{paddingLeft:4,}]}>b.</Text>
                        </View>
                        <View style={{ width : "46%" }}>
                            <Text style={[s.text]}>
                               Inspektur Mutu Hasil Perikanan Ahli Mahir/BBKIPM Jakarta I
                            </Text>
                        </View>
                    </View>         
                     <View style={s.tableRow}>
                        <View style={{ width: "3%"}}>
                            <Text style={[s.text,{paddingLeft:4}]}>c.</Text>
                        </View>
                        <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4}]}>
                                Tingkat menurut peraturan perjalanan dinas
                            </Text>
                        </View>
                        <View style={{ width: "3%"}}>
                        <Text style={[s.text,{paddingLeft:4}]}>c.</Text>
                        </View>
                        <View style={{ width : "46%" }}>
                            <Text style={[s.text]}>
                                C

                            </Text>
                        </View>
                    </View>            
            </View>
         </View>

        
        {/* 4 */}
        <View style={s.tableRow}>
            <View style={s.tableColNo}>
            <Text style={s.text}>4.</Text>
            </View>
            <View style={s.tableColLabel}>
            <Text style={s.text}>Maksud perjalanan dinas</Text>
            </View>
            <View style={s.tableColValue}>
            <Text style={s.text}>{data.maksud}</Text>
            </View>
        </View>

        {/* 5 */}
        <View style={s.tableRow}>
            <View style={s.tableColNo}>
            <Text style={s.text}>5.</Text>
            </View>
            <View style={s.tableColLabel}>
            <Text style={s.text}>Alat angkutan yang dipergunakan</Text>
            </View>
            <View style={s.tableColValue}>
            <Text style={s.text}>{data.transportasi}</Text>
            </View>
        </View>

        {/* 6 */}
        <View style={s.tableRow}>
            <View style={s.tableColNo}>
            <Text style={s.text}>6.</Text>
            </View>
            <View style={{ width :"97%", 
                    borderBottomWidth: 1,
                     }}>
                <View style={s.tableRow}>
                    <View style={{ width: "3%"}}>
                        <Text style={[s.text,{padding:4}]}>a.</Text>
                    </View>
                    <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{padding:4}]}>
                            Tempat berangkat
                        </Text>
                    </View>
                    <View style={{ width: "3%"}}>
                        <Text style={[s.text,{padding:4}]}>a.</Text>
                    </View>
                    <View style={{ width : "46%" }}>
                        <Text style={[s.text,{paddingTop:4}]}>
                            Balai Besar KIPM Jakarta I 
                            Bandara Soekarno-Hatta Tangerang
                        </Text>
                    </View>
                </View>
                
                    <View style={s.tableRow}>
                        <View style={{ width: "3%"}}>
                            <Text style={[s.text,{paddingLeft:4}]}>b.</Text>
                        </View>
                        <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4}]}>
                                Tempat tujuan
                            </Text>
                        </View>
                        <View style={{ width: "3%"}}>
                        <Text style={[s.text,{paddingLeft:4}]}>b.</Text>
                    </View>
                    <View style={{ width : "46%" }}>
                        <Text style={[s.text]}>
                            PT. Bumi Pertiwi Mulia - Jl.Pergudangan Bandara
                            Mas Blok M No.21, Kel. Selapanjang, Kec. Neglasari
                            Kota Tangerang

                        </Text>
                    </View>
                    </View>                 
            </View>
         </View>

        {/* 7 */}
        <View style={s.tableRow}>
            <View style={s.tableColNo}>
            <Text style={s.text}>7.</Text>
            </View>
            <View style={{ width :"97%", 
                    borderBottomWidth: 1,
                     }}>
                <View style={s.tableRow}>
                    <View style={{ width: "3%"}}>
                        <Text style={[s.text,{padding:4}]}>a.</Text>
                    </View>
                    <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{padding:4}]}>
                             Lamanya perjalanan dinas
                        </Text>
                    </View>
                    <View style={{ width: "3%"}}>
                        <Text style={[s.text,{padding:4}]}>a.</Text>
                    </View>
                    <View style={{ width : "46%" }}>
                        <Text style={[s.text,{paddingTop:4}]}>
                            1 (Satu) hari
                        </Text>
                    </View>
                </View>
                
                    <View style={s.tableRow}>
                        <View style={{ width: "3%"}}>
                            <Text style={[s.text,{paddingLeft:4,paddingBottom:4}]}>b.</Text>
                        </View>
                        <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4,paddingBottom:4}]}>
                                Tanggal berangkat
                            </Text>
                        </View>
                        <View style={{ width: "3%"}}>
                        <Text style={[s.text,{paddingLeft:4,paddingBottom:4}]}>b.</Text>
                        </View>
                        <View style={{ width : "46%" }}>
                            <Text style={[s.text,{paddingBottom:4}]}>
                                8 November 2025 

                            </Text>
                        </View>
                    </View>         
                     <View style={s.tableRow}>
                        <View style={{ width: "3%"}}>
                            <Text style={[s.text,{paddingLeft:4}]}>c.</Text>
                        </View>
                        <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4}]}>
                                Tanggal harus kembali/tiba di tempat
                            </Text>
                        </View>
                        <View style={{ width: "3%"}}>
                        <Text style={[s.text,{paddingLeft:4}]}>c.</Text>
                        </View>
                        <View style={{ width : "46%" }}>
                            <Text style={[s.text]}>
                                8 November 2025 

                            </Text>
                        </View>
                    </View>            
            </View>
         </View>

          {/* 8 */}
        <View style={s.tableRow}>
            <View style={s.tableColNo}>
            <Text style={s.text}>7.</Text>
            </View>
            <View style={{ width :"97%", 
                    borderBottomWidth: 1,
                     }}>
                <View style={s.tableRow}>
                    <View style={{ width: "18%"}}>
                        <Text style={[s.text,{paddingTop:4,paddingLeft:4}]}>Pengikut:</Text>
                    </View>
                    <View style={{ width : "30.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingTop:4}]}>
                             Nama
                        </Text>
                    </View>
                    <View style={{ width: "23%"}}>
                        <Text style={[s.text,{paddingTop:4,paddingLeft:4}]}>Tanggal Lahir</Text>
                    </View>
                    <View style={{ width : "27%" }}>
                        <Text style={[s.text,{paddingTop:4}]}>
                            Keterangan
                        </Text>
                    </View>
                </View>
                
                    <View style={s.tableRow}>
                        <View style={{ width: "3%"}}>
                            <Text style={[s.text,{paddingLeft:4}]}>a.</Text>
                        </View>
                        <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4}]}>
                                
                            </Text>
                        </View>
                        <View style={{ width: "23%"}}>
                        <Text style={[s.text,{paddingLeft:4}]}>

                        </Text>
                        </View>
                        <View style={{ width : "27%" }}>
                            <Text style={[s.text]}>
                            </Text>
                        </View>
                    </View>         
                     <View style={s.tableRow}>
                        <View style={{ width: "3%"}}>
                            <Text style={[s.text,{paddingLeft:4}]}>b.</Text>
                        </View>
                        <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4}]}>
                                
                            </Text>
                        </View>
                        <View style={{ width: "23%"}}>
                        <Text style={[s.text,{paddingLeft:4}]}>

                        </Text>
                        </View>
                        <View style={{ width : "27%" }}>
                            <Text style={[s.text]}>
                            </Text>
                        </View>
                    </View>    
                    <View style={s.tableRow}>
                        <View style={{ width: "3%"}}>
                            <Text style={[s.text,{paddingLeft:4}]}>c.</Text>
                        </View>
                        <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4}]}>
                                
                            </Text>
                        </View>
                        <View style={{ width: "23%"}}>
                        <Text style={[s.text,{paddingLeft:4}]}>

                        </Text>
                        </View>
                        <View style={{ width : "27%" }}>
                            <Text style={[s.text]}>
                            </Text>
                        </View>
                    </View>    
            </View>
         </View>

        {/* 9 */}
        <View style={s.tableRow}>
            <View style={s.tableColNo}>
            <Text style={s.text}>9.</Text>
            </View>
            <View style={{ width :"97%", 
                    borderBottomWidth: 1,
                     }}>
                <View style={s.tableRow}>
                    <View style={{ width: "3%"}}>
                        <Text style={[s.text]}></Text>
                    </View>
                    <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4}]}>
                             Pembebanan Anggaran 
                        </Text>
                    </View>
                    <View style={{ width: "3%"}}>
                        <Text style={[s.text,{padding:4}]}></Text>
                    </View>
                    <View style={{ width : "46%" }}>
                        <Text style={[s.text,{paddingTop:4}]}>
                            
                        </Text>
                    </View>
                </View>
                
                    <View style={s.tableRow}>
                        <View style={{ width: "3%"}}>
                            <Text style={[s.text,{paddingLeft:4,paddingBottom:4}]}>a.</Text>
                        </View>
                        <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4,paddingBottom:4}]}>
                                Instansi 
                            </Text>
                        </View>
                        <View style={{ width: "3%"}}>
                        <Text style={[s.text,{paddingLeft:4,paddingBottom:4}]}>a.</Text>
                        </View>
                        <View style={{ width : "46%" }}>
                            <Text style={[s.text,{paddingBottom:4}]}>
                                Stasiun Karantina Ikan, Pengendalian Mutu, dan
                                Keamanan Hasil Perikanan Merak TA. 2025
                            </Text>
                        </View>
                    </View>         
                     <View style={s.tableRow}>
                        <View style={{ width: "3%"}}>
                            <Text style={[s.text,{paddingLeft:4}]}>b.</Text>
                        </View>
                        <View style={{ width : "45.5%", borderRightWidth: 1 }}>
                        <Text style={[s.text,{paddingLeft:4}]}>
                                Mata Anggaran
                            </Text>
                        </View>
                        <View style={{ width: "3%"}}>
                        <Text style={[s.text,{paddingLeft:4}]}>b.</Text>
                        </View>
                        <View style={{ width : "46%" }}>
                            <Text style={[s.text]}>
                                
                            </Text>
                        </View>
                    </View>            
            </View>
         </View>

        <View style={s.tableRow}>
            <View style={s.tableColNo}>
            <Text style={s.text}>10.</Text>
            </View>
            <View style={s.tableColLabel}>
            <Text style={s.text}>Keterangan lain-lain : </Text>
            </View>
            <View style={s.tableColValue}>
            <Text style={s.text}>{data.transportasi}</Text>
            </View>
        </View>



       </View>


      {/* TTD */}

      <View style={[s.tableRow,{paddingTop:20}]}>
            <View style={{ width :'50%' }}> </View>
             <View style={{ width :'15%' }}> 
                <Text style={s.text}>
                Dikeluarkan di
                </Text>
             </View>
                <View style={{ width :'35%'}}>
                <Text style={s.text}>
                : Tangerang
                </Text>
            </View>
        </View>
        <View style={s.tableRow}>
            <View style={{ width :'50%' }}> </View>
             <View style={{ width :'15%' }}> 
                <Text style={s.text}>
                Tanggal 
                </Text>
             </View>
               <View style={{ width :'35%'}}>
                <Text style={s.text}>
                : 8 November 2025
                </Text>
            </View>
        </View>
        <View style={s.tableRow}>
            <View style={{ width :'50%' }}> </View>
             <View style={{ width :'30%'}}> 
                <Text style={[s.text,{paddingTop:20}]}>
                Pejabat Pembuat Komitmen
                </Text>
                <Text style={{ marginTop: 40, fontFamily: "Arial-Bold" }}>
            {data.ppkNama}
        </Text>
        <Text>NIP {data.ppkNip}</Text>
        </View>
                
        </View>
      
    </Page>
  </Document>
  );
}
